import PagePlaceholder from '../components/PagePlaceholder.jsx';

export default function TournamentResults() {
  return (
    <PagePlaceholder
      title="Results"
      note="Final standings, the bracket as it finished, and the night's stats."
    />
  );
}
